/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cms-card-container[_ngcontent-%COMP%]{max-width:300px;margin:auto}@media screen and (max-width:360px){.cms-card-container[_ngcontent-%COMP%]{padding-left:30px}}\n/*# sourceMappingURL=courses-grid.component.css.map*/"];
export { styles as styles };
